import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
var state = {
  refresh: 0
};
var fields = {
  enabled: true,
  label: '',
  loading: false
};
var mutations = {
  updateOne: function updateOne(state, payload) {
    var obj = _objectSpread({}, state[payload.name]);

    Object.keys(fields).forEach(function (key) {
      if (key !== 'name' && typeof payload[key] !== 'undefined') {
        obj[key] = payload[key];
      }
    });
    state[payload.name] = obj;
    state.refresh++;
  },
  setInitialValuesIfNeeds: function setInitialValuesIfNeeds(state, _ref) {
    var values = _ref.values;
    values.forEach(function (value) {
      var name = value.name,
          label = value.label;

      if (!state[name]) {
        var obj = _objectSpread({}, fields);

        obj.label = label;
        Vue.set(state, name, obj);
      } else if (state[name].label !== label) {
        state[name].label = label;
      }
    });
  }
};
export default {
  namespaced: true,
  mutations: mutations,
  state: state
};